;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.AflClubsLadder = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.AflClubsLadder,
		data: {},
		ladder_title: 'AFL Ladder',
		model: new Backbone.Model(),

		setDefaultModel(){
			this.model.set({
				ladder_title: this.ladder_title,
				SQUADS_URL:   CONFIG.SQUADS_URL,
				ladder: []
			});
		},
		initialize: function() {
			this.squads     = this.getOption('squads');
			this.collection = this.getOption('ladderCollection');

		this.setDefaultModel();

			this.squads
				.fetch({cache: true, expires: 60})
				.then(_.bind(function () {
					this.loadOfficialLadder();
				}, this));

		},

		loadOfficialLadder: function() {
			this.collection
				.getOfficialLadder()
				.fetch({cache: true, expires: 60})
				.then(_.bind(function () {
					this.setStats();
				}, this));

			return this;
		},

		setStats: function() {

			this.collection.forEach(function(model, index) {
				model.set({'index':index+1});
			});

			this.model.set({
				ladder: this.getCollection()
			});

			this.render();

			return this;
		},

		getCollection() {
			return this.collection.toJSON()
		}
	})

}(window, APP, Backbone, Marionette, $, _));

